import React from 'react';
import { EntityType } from '../../@types/entityTypes';
import { IFilterInput } from '../../graphql/schema/p4types';
import { IWorkspaceSelection, IWorkspaceSelectionState } from '../Workspace/useWorkspaceSelection';
import { IWorkspaceColumnOverride } from '../../@types/workspaceTypes';
import { IEditableDataGridColumnDef } from '../../@types/editableDataGridTypes';
import { IWorkspaceActionButtonsProps } from '../Workspace/WorkspaceActionButtons';

export type WorkspaceContextType = {
  defaultContextValue: boolean;
  reloadData: () => Promise<any>;
  selectionState?: IWorkspaceSelectionState;
  screenReference: string;
  entity: EntityType;
  currentView?: any;
  workspaceFilters?: Array<IFilterInput>;
  title: string;
  workspaceSelection?: IWorkspaceSelection;
  columnOverrides?: IWorkspaceColumnOverride;
  rowCount?: number;
  selectedRowCount?: number;
  availableColumnsFilter: (column: IEditableDataGridColumnDef) => boolean;
  availableFiltersFilter: (column: IEditableDataGridColumnDef) => boolean;
  embeddedView?: boolean;
  workspaceActionButtons?: IWorkspaceActionButtonsProps;
  onRowSelect?: Function;
  autofocusSearch?: boolean;
};

const WorkspaceContext = React.createContext({ defaultContextValue: true } as WorkspaceContextType);
export default WorkspaceContext;
